// extracted by mini-css-extract-plugin
module.exports = {"videos_section":"XWx05","video_list":"WVIzo","vdoactive":"YHvpP","border_color":"uUO3p","player_container_wrap":"bbR7V"};